import React from 'react';
import Box from '@mui/material/Box';
import type { LandingAgentTurn } from '../../stores/slices/landingAgentSlice';
import { tookOf } from '../../stores/slices/progress';
import { WorkedOut } from './ProgressLine';

/**
 * F4 (#1858 §6): "Took 21 s · How this was worked out", in the answer's row. "Took" is the server's own measure
 * (`answer_timed`, omitted for an answer from before F4); the steps open below the row.
 */
export default function DoneLine({ turn, open = false, onToggle = () => undefined }: { turn: LandingAgentTurn; open?: boolean; onToggle?: () => void }) {
  const took = tookOf(turn);
  const dot = <Box component="span" aria-hidden sx={{ color: 'var(--ink-4, var(--ink-3))' }}>·</Box>;
  return (
    <Box data-testid="done-line" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap', fontSize: 12.5, color: 'var(--ink-3)' }}>
      {took != null && <><Box component="span" data-testid="done-took">Took {took} s</Box>{dot}</>}
      <WorkedOut open={open} onToggle={onToggle} />
    </Box>
  );
}
